export default __webpack_public_path__ + "static/media/SENAIT_NL_EPILOGFIN2.67bdadba.mp3";